import React from "react";
import Dropdown from "../Dropdown/dropdown";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";
import { useGetResultTypeOptions } from "../../hooks/resultsHooks/results.hooks";

interface IProps {
  onResultTypeSelect: (selectedResultType: any) => unknown;
  selectedResultType: string | null;
}

export const ResultTypeDropdown = ({
  onResultTypeSelect,
  selectedResultType,
}: IProps) => {
  const { data: RESULT_TYPE_OPTIONS } = useGetResultTypeOptions();

  return (
    <Dropdown
      label="Result"
      options={RESULT_TYPE_OPTIONS || []}
      selectedOption={getSelectedOptionFromValue(
        RESULT_TYPE_OPTIONS || [],
        selectedResultType,
      )}
      setSelectedOption={(option) => {
        onResultTypeSelect(option);
      }}
    />
  );
};
